import Swiper from 'swiper'

for (let swiperElement of document.querySelectorAll('.wpce-swiper')) {
  let swiper = new Swiper(`#${swiperElement.dataset.swiperId}`, {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 15,
    centeredSlides: false,

    // If we need pagination
    pagination: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      565: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1100: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 41,
      },
    },
  })

  let prevButton = swiperElement.querySelector('.custom-button-prev')
  let nextButton = swiperElement.querySelector('.custom-button-next')

  prevButton.addEventListener('click', () => {
    swiper.slidePrev()
  })
  nextButton.addEventListener('click', () => {
    swiper.slideNext()
  })

  function handleEnds() {
    swiperElement.classList.toggle('is-beginning', swiper.isBeginning)
    swiperElement.classList.toggle('is-end', swiper.isEnd)

    prevButton.disabled = swiper.isBeginning
    nextButton.disabled = swiper.isEnd
  }
  swiper.on('slideChange', handleEnds)
  handleEnds()
}
